import { erpAxios } from '.';

const deleteReplacementLoan = async (id) => {
  const res = await erpAxios.delete(`/loanReleaseAnalytics/${id}`);
  return res;
};

export default deleteReplacementLoan;
